"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabContent(props) {
  let render = null;

  _react.default.Children.forEach(props.children, child => {
    if (props.currentKey === child.key) {
      render = child;
    }
  });

  return render;
}

var _default = /*#__PURE__*/_react.default.memo(TabContent);

exports.default = _default;